export default "__VITE_ASSET__ddd92c94__"